import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';

import { StateController } from '../helpers/state/state-management/state-controller';
import accountInfo from '../helpers/state/account-info';
import { getMainPage } from '../helpers/page-name';
import { ifDefined } from 'lit/directives/if-defined';
import { sendMapLinkViaSMS } from '../helpers/api/messages-api';
import topicData from '../helpers/state/topic-data';

@customElement('send-map-to-phone-modal')
export class ShareMapComponent extends LitElement {
    static amplitude_callsite: string = 'Send Map to Phone Modal';



    @state()
    phoneNumber: string = '';

    @property()
    qrCodeLink: string | undefined;

    private readonly bindAccountState = new StateController(this, accountInfo);

    onChangePhoneNumber(e: any) {
        this.phoneNumber = e.detail.value;
    }

    async sendMessage() {
        try{
            await sendMapLinkViaSMS(topicData.topicId, topicData.publicShareLink, this.phoneNumber, topicData.topic?.organization_id?.$oid ?? '');
            getMainPage().errorToastElement.showToast('Message sent successfully!');
        } catch (error) {
            getMainPage().errorToastElement.showToast('Failed to send message. Please try again later.');
        }
    }

    render() {
        return html`
            <div class="modal-wrapper">
                <div class="modalTitle">View On Phone</div>
                <form-input
                    type="string"
                    label="Phone Number"
                    placeholder="Enter your phone number"
                    value="${this.phoneNumber ?? ''}"
                    @change="${this.onChangePhoneNumber}"
                >
                </form-input>
                <div class="info-description">
                    You will receive a message with the link to this map.
                </div>
                <form-button ?fullWidth=${true} @click=${this.sendMessage}>
                    Send Map Link to My Phone
                </form-button>
                <div class="orDivider">OR</div>
                <div class="qrCodeWrapper">
                    <div class="qr-description">
                        Scan QR code with your camera
                    </div>
                    ${this.qrCodeLink ? html`
                    <img src=${ifDefined(this.qrCodeLink)} class="qrCodeImg" alt="qr code" />`
                    : ''}
                </div>
            </div>
            <error-toast id="errorToast"></error-toast>
        `;
    }

    static get styles() {
        return css`
            :host {
                display: block;
            }

            .modal-wrapper {
                padding: 1.5rem;
                font-size: 0.8rem;
            }

            .info-description {
                margin-top: 0.5rem;
                margin-bottom: 1rem;
            }

            .modalTitle {
                font-size: 1rem;
                font-weight: 700;
                color: var(--main-primary-color);
                text-align: center;
                margin-top: 0.5rem;
                margin-bottom: 1.5rem;
                width: 100%;
            }

            .orDivider {
                display: flex;
                flex-direction: row;
                align-items: center;
                margin: 1rem 0;
            }
            .orDivider:before, .orDivider:after {
                content: "";
                flex-grow: 1;
                height: 1px;
                background-color: var(--theme-input-border-color);
                margin: 0 1rem;
            }

            .qrCodeWrapper {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            }

            .qr-description {
                font-weight: 700;
            }

            .qrCodeImg {
                height: 100px;
            }
        `;
    }
}
